<template>
  <div class="article_con_in">
    <div class="form_con" v-if="!zhucesuccess">
      <div class="title_bg">
        <img src="../../../assets/img/meida_topbg.png" />
      </div>
      <div class="title">{{ mediaSc.webName }}</div>
      <div class="line"></div>
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="180px"
        class="demo-formData"
      >
        <el-form-item label="姓名" prop="regName">
          <el-input v-model="formData.regName" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="formData.gender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传图片验证码">
          <el-input
            v-model="regImgCode"
            auto-complete="off"
            placeholder="验证码"
            style="width: 63%"
            @input="handleRegImgCode"
          >
          </el-input>
          <div class="login-code">
            <img :src="codeUrlimg" @click="getCodeImg" class="login-code-img" />
          </div>
        </el-form-item>
        <el-form-item label="照片" prop="regImg">
          <div @click="handleHasUpload($event)">
            <ImageUpload
              :disabled="regImgDisabled"
              @remove="handleImageRemove"
              @input="uploadRegImg"
              :code="regImgCode"
              :limit="1"
              :uuid="uuidImg"
              :key="timeStamp"
              :value="formData.regImg"
            />
            <!-- <div v-if="regImgDisabled" class="upload-mask">请先填写验证码</div> -->
          </div>
        </el-form-item>

        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="formData.idCard" placeholder="身份证号"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="address">
          <el-input
            v-model="formData.address"
            placeholder="联系地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="工作单位" prop="unitName">
          <el-input
            v-model="formData.unitName"
            placeholder="工作单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="职务" prop="position">
          <el-input v-model="formData.position" placeholder="职务"></el-input>
        </el-form-item>
        <el-form-item label="记者证号" prop="pressCard">
          <el-input
            v-model="formData.pressCard"
            placeholder="记者证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请种类" prop="applyType">
          <el-checkbox-group v-model="formData.applyType">
            <el-checkbox label="文字记者"></el-checkbox>
            <el-checkbox label="摄影记者"></el-checkbox>
            <el-checkbox label="电视记者"></el-checkbox>
          </el-checkbox-group>
          其他<el-input
            v-model="other"
            style="width: 70%; margin-left: 10px"
            placeholder="其他"
            @blur="handleOther"
          ></el-input>
        </el-form-item>

        <el-form-item label="移动电话" prop="phone">
          <el-input v-model="formData.phone" placeholder="移动电话"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="formData.email" placeholder="电子邮箱"></el-input>
        </el-form-item>
        <el-form-item label="住宿要求" required>
          <el-date-picker
            v-model="formData.date"
            type="daterange"
            start-placeholder="入住日期"
            end-placeholder="离开日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            id="custom-date-picker"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="拟采访嘉宾" prop="interview">
          <el-input
            v-model="formData.interview"
            placeholder="拟采访嘉宾"
          ></el-input>
        </el-form-item>
        <el-form-item label="拟发布专题内容及篇幅" prop="specialTopic">
          <el-input
            v-model="formData.specialTopic"
            placeholder="拟发布专题内容及篇幅"
          ></el-input>
        </el-form-item>
        <el-form-item label="拟发布时间">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="formData.publishTime"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否有媒体购票需求" prop="ticketDemand">
          <el-radio-group v-model="formData.ticketDemand">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input
            v-model="formData.code"
            auto-complete="off"
            placeholder="验证码"
            style="width: 65%"
          >
          </el-input>
          <div class="login-code">
            <el-button
              style="
                background: #165dff;
                color: #fff;

                height: 40px;
                border-radius: 0;
              "
              @click="getCodeBtn"
              v-if="!showCodeImg"
              >获取验证码</el-button
            >
            <img
              v-if="showCodeImg"
              :src="codeUrl2"
              @click="getCode"
              class="login-code-img"
            />
          </div>
        </el-form-item>
        <el-checkbox v-model="formData.zhuce" style="margin: 0px 0px 25px 140px"
          >我已阅读</el-checkbox
        >
        <span
          @click="handleZC"
          style="color: #165dff; cursor: pointer; font-size: 14px"
        >
          {{ mediaSc.webName }}
        </span>
        <el-form-item>
          <el-button
            style="
              background: #165dff;
              color: #fff;
              width: 160px;
              height: 48px;
              border-radius: 0;
            "
            @click="onSubmit"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="success_con" v-else>
      <div class="success_img">
        <img src="../../../assets/img/success.png" />
      </div>
      <div class="succsee_title">提交成功</div>
      <div class="succsee_word">审核结果将发送到您的邮箱，请及时查收</div>
      <div class="succsee_word">点击确定将返回<span>首页</span></div>
      <div class="btn_con">
        <el-button
          style="
            background: #165dff;
            color: #fff;
            width: 160px;
            height: 48px;
            border-radius: 0;
          "
          @click="toback"
          >确定</el-button
        >
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisibleZC"
      title="注册须知"
      width="800"
      append-to-body
      center
    >
      <div class="dialog_content">
        <p v-html="mediaSc.webNote"></p>
        <!-- <p>
          第十一届乌镇戏剧节将于2024年10月17日至10月27日在中国乌镇举行。欢迎广大媒体朋友们来到乌镇,与我们共同见证这一场戏剧盛事。您可以登陆乌镇戏剧节官方网站媒注册中心在线报名注册。乌镇戏剧节媒体中心将根据注册信息进行资格审核。
          在您进入报名注册系统为本人(或者替他人)填写注册信息之前，请仔细阅读以下须知:
        </p>
        <p>一、报名注册对象</p>
        <p>
          ①在经国家广播电视总局和网信部门注册备案的媒体单位中从事新闻采编的工作人员;
        </p>
        <p>
          ②具有境外新闻机构颁发的相关资格证明且持有中国外事部门核发的记者签证的境外媒体记者;
        </p>
        <p>
          ③其他自媒体,包括:抖音、快手、微博、b站、小红书、微信、百度、网易等网络社区上活跃度较高的KOL。
        </p>
        <p>二、报名注册注意事项</p>
        <p>①报名注册官方网站:www.wuzhenfestival.com</p>
        <p>②报名注册时间:2024年8月6日至9月23日</p>
        <p>
          ③报名表填写时,请上传个人正面2寸免冠照（大小在1M以内），并填写您的常用手机号
        </p>
        <p>④所有注册信息请务必按要求填写 三、与我们联络</p>
        <p>①媒体中心电话:0573-88732588</p>
        <p>②媒体中心邮箱:media@wuzhenfestival.cn</p>
        <p>乌镇戏剧节组委会 2024年8月</p> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getCodeImg,
  addMediaRegistry,
  getMediaRegistryConfig,
} from '@/assets/api';
import { newproxyPut } from '@/utils/newproxy';
import ImageUpload from '@/components/ImageUpload';

export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      captchaEnabled: true,

      codeUrl2: '',
      formData: {
        regName: '',
        gender: 1,
        regImg: '',
        idCard: '',
        address: '',
        unitName: '',
        position: '',
        pressCard: '',
        applyType: [],
        phone: '',
        email: '',
        date: [],
        interview: '',
        specialTopic: '',
        publishTime: null,
        ticketDemand: null,
        code: '',
        uuid: '',
      },
      other: '',
      rules: {
        regName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' },
        ],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        regImg: [{ required: true, message: '请上传图片', trigger: 'change' }],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' },
        ],
        unitName: [
          { required: true, message: '请输入工作单位', trigger: 'blur' },
        ],
        position: [{ required: true, message: '请输入职务', trigger: 'blur' }],
        pressCard: [
          { required: true, message: '请输入记者证号', trigger: 'blur' },
        ],
        applyType: [
          { required: true, message: '请选择申请种类', trigger: 'change' },
        ],
        phone: [{ required: true, message: '请输入移动电话', trigger: 'blur' }],
        email: [{ required: true, message: '请输入电子邮箱', trigger: 'blur' }],
        date: [
          {
            type: 'date',
            required: true,
            message: '请选择住宿日期',
            trigger: 'change',
          },
        ],
        interview: [
          { required: true, message: '请输入拟采访嘉宾', trigger: 'blur' },
        ],
        specialTopic: [
          {
            required: true,
            message: '请输入拟发布专题内容及篇幅',
            trigger: 'blur',
          },
        ],
        publishTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
        ticketDemand: [
          {
            required: true,
            message: '请选择是否有媒体购票需求',
            trigger: 'change',
          },
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      dialogVisible: false,
      dialogVisibleZC: false,
      showCodeImg: false,
      //上传图片需要验证码参数
      codeUrlimg: '',
      regImgDisabled: true,
      regImgCode: '',
      uuidImg: '',
      timeStamp: '',
      zhucesuccess: false,
      mediaSc: '', //媒体注册手册
    };
  },
  mounted() {
    this.getCodeImg();
    this.getMediaRegit();
  },
  methods: {
    uploadRegImg(list) {
      this.formData.regImg = list;
      if (list) {
        this.$refs.formData.clearValidate(['regImg']);
      }
    },
    handleImageRemove() {
      console.log('图片已删除');
      this.formData.regImg = ''; // 清空图片数据
      this.regImgCode = ''; // 清空验证码
      this.regImgDisabled = true; // 禁用上传按钮
      this.getCodeImg(); // 更新验证码
      this.$message.info(
        '图片已删除，验证码已更新，请重新输入验证码后上传图片'
      );
    },
    handleZC() {
      this.dialogVisibleZC = true;
    },
    //上传图片的验证码
    getCodeImg() {
      getCodeImg().then((res) => {
        if (res.code == 200) {
          this.codeUrlimg = 'data:image/gif;base64,' + res.img;
          this.uuidImg = res.uuid;
        }
      });
    },
    // formData的验证码
    getCode() {
      getCodeImg().then((res) => {
        if (res.code == 200) {
          this.codeUrl2 = 'data:image/gif;base64,' + res.img;
          this.formData.uuid = res.uuid;
        }
      });
    },
    // 显示验证码
    getCodeBtn() {
      this.showCodeImg = true;
      this.getCode();
    },
    handleRegImgCode(value) {
      if (value) {
        this.regImgCode = value; // 更新验证码
        // this.regImgDisabled = false;
        this.regImgDisabled = !value.trim(); // 如果验证码为空，则禁用上传按钮
        this.timeStamp = new Date().getTime();
      }
    },
    //点击上传先填验证码
    handleHasUpload(event) {
      event.stopPropagation(); // 阻止事件冒泡
      if (this.regImgDisabled) {
        this.$message.error('请先填写图片验证码');
      }
    },
    handleOther(value) {
      if (value != '') {
        this.formData.applyType.push('@133456');
      } else {
        this.formData.applyType = this.formData.applyType.filter(
          (a) => a != '@133456'
        );
      }
    },
    //注册须知
    getMediaRegit() {
      getMediaRegistryConfig({ siteId: this.$store.state.siteValue }).then(
        (res) => {
          if (res.code == 200) {
            this.mediaSc = res.data.records[0];
          }
        }
      );
    },

    onSubmit() {
      let array = [...this.formData.applyType];
      if (this.other != '') {
        array.push(this.other);
      }
      this.formData.applyType = [...new Set(array)];
      this.formData.applyType = this.formData.applyType.filter(
        (a) => a != '@133456'
      );
      this.$refs.formData.validate((valid) => {
        if (valid) {
          if (!this.formData.zhuce) {
            return this.$message.error('请勾选我已阅读媒体注册须知');
          }
          let data = {
            ...this.formData,
            checkInTime: this.formData.date[0],
            leaveTime: this.formData.date[1],
            applyType: this.formData.applyType.join(','),
            siteId: this.$store.state.siteValue,
          };
          addMediaRegistry(newproxyPut(data)).then((res) => {
            if (res.code == 200) {
              this.zhucesuccess = true;
            }
          });
        } else {
          return false;
        }
      });
    },
    toback() {
      this.$router.push({ path: '/' });
      this.zhucesuccess = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-wrapper {
  position: relative;
}
.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  font-size: 14px;
  z-index: 10;
  pointer-events: none;
}
.article_con_in {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  margin: 2.5rem 0;
  padding-bottom: 1.875rem;
  .form_con {
    width: 80%;
    margin: 0 auto;
    .title_bg {
      img {
        width: 100%;
        object-fit: cover;
        object-position: center; /* 图片的中心与容器的中心对齐 */
      }
    }
    .title {
      text-align: center;
      font-size: 2.25rem;
      font-family: SourceHanSansCN-Medium;
      margin: 2.25rem 0 2.25rem 0;
    }
    .line {
      width: 100%;
      margin: 0.75rem 0 5rem;
      height: 0.125rem;
      background: linear-gradient(
        to right,
        rgba(170, 229, 239, 1),
        rgba(177, 187, 255, 1)
      );
    }
    .demo-formData {
      width: 70%;
      margin: 0 auto;
      .login-code {
        width: 33%;
        height: 38px;
        float: right;
        img {
          height: 38px;
          cursor: pointer;
          vertical-align: middle;
        }
      }
    }
  }
  .success_con {
    width: 30%;
    margin: 0 auto;
    padding: 10% 0;
    text-align: center;
    .success_img {
      width: 10rem;
      height: 10rem;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .succsee_title {
      font-size: 1.125rem;
      font-family: SourceHanSansCN-Medium;
    }
    .succsee_word {
      color: #b9bcbf;
      font-size: 0.875rem;
      margin: 0.625rem 0;
      span {
        color: #424451;
        margin-left: 0.3125rem;
      }
    }
  }
}
::v-deep {
  .el-input__inner {
    background: #f2f3f5;
    border: #f2f3f5;
  }
  .el-dialog__header {
    border-top: 0.3125rem solid;
    border-image: linear-gradient(
        to right,
        rgba(170, 229, 239, 1),
        rgba(177, 187, 255, 1)
      )
      6 6;
  }
  .el-dialog__title {
    font-size: 2.25rem;
    font-family: SourceHanSansCN-Medium;
    padding-top: 1.875rem;
  }

  // 日期
  .el-input__prefix {
    right: 5px;
    left: auto !important;
    color: #4e5969;
  }
  .el-input__suffix {
    right: 5px;
    left: auto !important;
  }
  .el-range__icon {
    float: right;
    margin-left: 0;
    margin-right: 5px;
  }

  // 日期范围图标
  .el-date-editor {
    width: 100%;
    position: relative;
    .el-range-input {
      background: none;
    }
    .el-input__prefix {
      right: 5px;
      left: auto !important;
    }
    .el-input__icon.el-icon-date.el-range__icon {
      position: absolute;
      right: 5px;
      top: 5px;
      color: #4e5969;
      // margin-left: 0;
      // margin-right: 5px;
    }
  }
  .el-input__inner:hover {
    background: #e5e6eb !important;
  }

  .el-input__inner:focus {
    border: solid 1px #409eff !important;
    background: #fff !important;
  }
}
.dialog_content {
  width: 90%;
  margin: 0 auto;
  line-height: 40px;
  font-size: 1rem;
}
</style>
